import api from './api';

export interface ProviderGroup {
  id: string;
  organizationId: string;
  name: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
  providers?: { id: string; name: string }[];
}

export interface CreateProviderGroupDto {
  name: string;
  description?: string;
  isActive?: boolean;
  providerIds?: string[];
}

export const providerGroupsService = {
  getAll: async (): Promise<ProviderGroup[]> => {
    const response = await api.get('/provider-groups');
    return response.data;
  },

  getById: async (id: string): Promise<ProviderGroup> => {
    const response = await api.get(`/provider-groups/${id}`);
    return response.data;
  },

  create: async (data: CreateProviderGroupDto): Promise<ProviderGroup> => {
    const response = await api.post('/provider-groups', data);
    return response.data;
  },

  update: async (id: string, data: CreateProviderGroupDto): Promise<ProviderGroup> => {
    const response = await api.patch(`/provider-groups/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/provider-groups/${id}`);
  },
};
